import {Component, Input} from "@angular/core";
import {Facet} from "../../../record/feature-print-models";

@Component({
  selector: 'richemont-facet',
  templateUrl: './richemont-facet.component.html',
  styleUrls: ['./richemont-facet.component.scss']
})
export class RichemontFacetComponent {
  @Input() public facet: Facet | undefined;
  @Input() public previewImageUrl: string | null = null;
}
